import { AppFooter, AppNavbar } from "../../components";
import { ShopScreen1, ShopScreen1alt, ShopScreen2 } from "../../containers";
import "./Shop.css";


const Story = () => {

    return (
        <div className="shope">
            <AppNavbar/>
            <ShopScreen1alt/>
            <ShopScreen1/>
            <ShopScreen2/>
            <AppFooter/>
        </div>
    )
};

export default Story;